<template>
  <div class="image-container" :class="props.isLarge ? 'large' : ''">
    <img :src="props.image.thumbnailUrl || props.image.url" @contextmenu.prevent alt="Property Image" />
    <Badge v-if="props.isCover" label="Cover photo" variant="grey" size="small" class="cover-badge" />
  </div>
</template>

<script setup lang="ts">
import { Badge } from '@tallo/design-system';
import { FileDto } from '@tallo/file-manager';

const props = withDefaults(
  defineProps<{
    image: FileDto;
    isCover?: boolean;
    isLarge: boolean;
  }>(),
  {
    isCover: false,
    isLarge: false,
  },
);
</script>

<style scoped lang="scss">
@import 'styles/mixins/layout.mixins';

.image-container {
  position: relative;
  width: 13.625rem;
  height: 13.625rem;

  &.large {
    width: 19.5rem;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
    position: relative;
    border-radius: var(--t-border-radius-sm);
    padding: 0;
    margin: 0;
    user-select: none;

    @include mobile {
      height: auto;
      aspect-ratio: 1/1;
    }
  }

  .cover-badge {
    position: absolute;
    bottom: var(--t-spacing-md);
    left: var(--t-spacing-sm);
  }
}
</style>
